const _ = require('underscore');
const logger = require('utilities/logger');

function filledArray(size, value) {
	var a = Array(size),
		i;
	if (a.fill) {
		a.fill(value);
	} else {
		for (i = 0; i < size; i++) {
			a[i] = value;
		}
	}
	return a;
}

function rangeArray(start, end) {
	var a = [];
	for (var i = start; i < end; i++) {
		a.push(i);
	}
	return a;
}

function validatedIndexes(indexes, length) {
	var indexes2 = {
		start: Math.min(length, Math.max(0, indexes.start)),
		end: Math.max(0, Math.min(length, indexes.end))
	};

	if (indexes2.start > indexes2.end) {
		return {
			start: indexes2.end,
			end: indexes2.start
		};
	} else {
		return indexes2;
	}
}

function RangeConverter(el, content) {
	this.el = el;
	this.content = content;
}

var HTML_TAG_OR_ENTITY = /(<([^>]+)>|\&#?[a-z0-9]{2,12};)/gi;

/**
 * this method takes a start/end and returns a start end whose indexes are
 * valid and should be on whole-word boundaries. This fixes the issues we had
 * with legacyRangeToIndexes output on old records. The indexes may not be
 * 100% correctly adapted, but the whole word selection keeps it very close.
 *
 * @param  {object} indexes start/end that may be invalid
 * @return {object}         start/end that will be valid
 */
RangeConverter.prototype.fixLegacyIndexes = function (indexes) {
	var totalTagContentBeforeStart = 0;

	// allow browser to make its changes to the source
	var $div = $('<div></div>').html(this.content);
	var content = $div[0].innerHTML;
	var text = $div.text();

	// start might be in the middle of a tag, if so add the space before it's closed
	content.replace(HTML_TAG_OR_ENTITY, function (tag, g1, g2, startIdx) {
		var endIdx = startIdx + tag.length;
		if (startIdx < indexes.start && endIdx > indexes.start) {
			totalTagContentBeforeStart += indexes.start - startIdx;
		}
	});

	(content.substring(0, indexes.start).match(HTML_TAG_OR_ENTITY) || []).forEach(tag => (totalTagContentBeforeStart += tag.length));

	var totalTagContentBeforeEnd = totalTagContentBeforeStart;

	(content.substring(indexes.start, indexes.end).match(HTML_TAG_OR_ENTITY) || []).forEach(tag => (totalTagContentBeforeEnd += tag.length));

	var scanForValidWholeWordFrom = function (i, direction, boundaryDirection) {
		var MAX = 30,
			startedAt = i;

		while (Math.abs(i - startedAt) < MAX && text.charAt(i + direction) && !text.charAt(i + boundaryDirection).match(/\s/)) {
			i += direction;
		}

		return { distance: Math.abs(startedAt - i), i: i };
	}.bind(this);

	indexes = validatedIndexes(
		{
			start: indexes.start - totalTagContentBeforeStart,
			end: indexes.end - totalTagContentBeforeEnd
		},
		text.length
	);

	// if we ended up with a 0-length selection then move the start 10
	// character back, or if we're too close the the beginning, move the
	// end out 10 characters. If the text is less than 10 chars (?!) then
	// do nothing
	if (text.length > 10 && indexes.start === indexes.end) {
		if (indexes.start >= 10) {
			indexes.start -= 10;
		} else {
			indexes.end += 10;
		}
	}

	var e1 = scanForValidWholeWordFrom(indexes.end - 1, 1, 1),
		e2 = scanForValidWholeWordFrom(indexes.end - 1, -1, 1);

	var s1 = scanForValidWholeWordFrom(indexes.start, 1, -1),
		s2 = scanForValidWholeWordFrom(indexes.start, -1, -1);

	indexes = {
		start: s1.distance > s2.distance ? s2.i : s1.i,
		end: (e1.distance > e2.distance ? e2.i : e1.i) + 1
	};

	return validatedIndexes(indexes, text.length);
};

/**
 * Convert from an object with {start, end} html source indexes to a range with
 * {startContainerPath, endContainerPath, startOffset, endOffset}, compatible with
 * Marklib.Rendering().renderWithResult() as wel as RangeConverter.rangeToIndexes
 *
 * @param  {object} indexes start/end values
 * @return {object}         a range (called result in Marklib)
 */
RangeConverter.prototype.indexesToRange = function (indexes) {
	var startElement, endElement, startOffset, endOffset;

	var start = indexes.start,
		end = indexes.end,
		count = 0;

	// TODO use iterateTextNodes
	(function traverse(el) {
		if (el.childNodes.length) {
			_.toArray(el.childNodes).forEach(function (child) {
				traverse(child);
			});
		} else {
			var element = $(el);

			if (!startElement) {
				if (count + element.text().length >= start) {
					startElement = element;
					startOffset = start - count;
				}
			}

			if (!endElement) {
				if (count + element.text().length >= end) {
					endElement = element;
					endOffset = end - count;
				}
			}

			count += element.text().length;
		}
	})(this.el);

	var range = document.createRange();

	range.setStart(startElement[0], startOffset);
	range.setEnd(endElement[0], endOffset);

	return range;
};

var isValidTextNode = function (node) {
	if (!node) {
		return false;
	}
	var isTextNode = node.nodeType === node.TEXT_NODE;
	var hasNodeValue = node.nodeValue !== undefined && node.nodeValue !== null;

	return isTextNode && hasNodeValue;
};

var findNextTextNode = function (node, offset, atEnd, depth) {
	//Check if top level is a valid text node
	if (isValidTextNode(node)) {
		return node;
	}

	// If not the top level, check the children
	if (node.childNodes && node.childNodes.length > offset) {
		for (var i = atEnd ? offset : offset + 1; i < node.childNodes.length; i++) {
			if (isValidTextNode(node.childNodes[i])) {
				return node.childNodes[i];
			}
		}
	}

	// Only go over 3 siblings
	if (depth > 3) {
		return null;
	}

	// Step to the next sibling. Very likely to get a hit
	// as there are text nodes between most elements in article bodies
	return findNextTextNode(node.nextSibling, offset, null, depth + 1 || 1);
};

RangeConverter.prototype._textNodeAndOffset = function (container, offset, atEnd) {
	var node = container.childNodes[atEnd ? offset - 1 : offset];
	var searchNode = null;
	// Didn't find text node.
	if (!isValidTextNode(node)) {
		// Was the container a valid text node?
		if (isValidTextNode(container)) {
			node = container;
		} else {
			searchNode = findNextTextNode(container, offset, atEnd);
			if (searchNode) {
				node = searchNode;
			}
		}
	}

	return {
		node: node,
		offset: atEnd ? node.textContent.length : 0
	};
};

/**
 * Used when a user selects into the next paragraph without selecting a character
 * this should find the previous node that has children nodes.
 *
 * @param {Element} - element that user selected zero index of. Start walking back here.
 *
 **/
RangeConverter.prototype._previousElTextNodeAndOffset = function (container) {
	let previousEl = container;
	let previousTextEl = null;

	// Walk backwards up the dom using previousElementSibling
	// until we find a previous sibling with children, OR
	// run out of nodes
	while (previousTextEl === null && previousEl !== null) {
		previousEl = previousEl.previousElementSibling;

		// Check that it contains children, use last child as the node.
		if (previousEl && previousEl.childNodes && previousEl.childNodes.length) {
			previousTextEl = previousEl.childNodes[previousEl.childNodes.length - 1];
		}
	}

	return {
		node: previousTextEl,
		offset: previousTextEl.textContent.length ? previousTextEl.textContent.length : 0
	};
};

/**
 * The spec allows startContainer and endContainer of a range to either be a
 * text node or any other DOM node. Marklib cannot handle Range objects correctly
 * when the nodes aren't text nodes. This method alters the range in place so that
 * startContainer and endContainer are both text nodes. If both containers are already
 * text nodes then this is a no-op.
 *
 * @param  {Object} range A native browser range object (that is startContainer NOT startContainerPath et al)
 */
RangeConverter.prototype.ensureRangeContainersAreTextNodes = function (range) {
	if (range.startContainer.nodeType !== range.startContainer.TEXT_NODE) {
		let nodeOffset = this._textNodeAndOffset(range.startContainer, range.startOffset, false);
		if (!nodeOffset.node) {
			throw new Error('Failed to convert range to text nodes');
		}
		range.setStart(nodeOffset.node, nodeOffset.offset);
	}

	if (range.endContainer.nodeType !== range.endContainer.TEXT_NODE) {
		let nodeOffset = null;
		logger.info('about to correct endContainer, offset is', range.endOffset);
		// End offset is 0, we actually need the previous element.
		// Most likely caused by highlighting to the end of a paragraph.
		if (range.endOffset === 0) {
			nodeOffset = this._previousElTextNodeAndOffset(range.endContainer);
		} else {
			nodeOffset = this._textNodeAndOffset(range.endContainer, range.endOffset, true);
		}

		if (nodeOffset && !nodeOffset.node) {
			throw new Error('Failed to convert range to text nodes');
		}
		range.setEnd(nodeOffset.node, nodeOffset.offset);
	}
};

/**
 * Convert from a range of {startContainerPath, endContainerPath, startOffset, endOffset}
 * to simple {start, end} into the HTML source. You may also pass a native browser range
 * object from document.createRange {startContainer, endContainer, startOffset, endOffset}
 * this is compatible with new Marklib.Rendering().renderWithRange(...).serialize()
 *
 * @param  {object} path a range
 * @return {object}      an object with {start, end} props indicating offsets into the HTML source
 */
RangeConverter.prototype.rangeToIndexes = function (path) {
	var cleanWrapper = document.createElement('DIV');

	var cleanEl = document.createElement('DIV');
	cleanWrapper.appendChild(cleanEl);
	cleanEl.innerHTML = this.content;
	cleanEl.id = 'scratch';

	var text = $(cleanWrapper).text();

	var scratchNodeStart = $(cleanWrapper).clone(),
		scratchNodeEnd = $(cleanWrapper).clone(),
		startElem,
		endElem;

	var startOffset = path.startContainerPath.split(/;/);
	var startChildOffset = parseInt(startOffset[1]);

	if (startOffset[0]) {
		startElem = $('#' + cleanEl.id + '>' + startOffset[0], scratchNodeStart)[0].childNodes[startChildOffset];
	} else {
		startElem = scratchNodeStart[0].childNodes[0].childNodes[startChildOffset];
	}

	var endOffset = path.endContainerPath.split(/;/);
	var endChildOffset = parseInt(endOffset[1]);

	if (endOffset[0]) {
		endElem = $('#' + cleanEl.id + '>' + endOffset[0], scratchNodeEnd)[0].childNodes[endChildOffset];
	} else {
		endElem = scratchNodeEnd[0].childNodes[0].childNodes[endChildOffset];
	}

	startElem.textContent = startElem.textContent.substring(0, path.startOffset) + 'RWSTART' + startElem.textContent.substring(path.startOffset);
	endElem.textContent = endElem.textContent.substring(0, path.endOffset) + 'RWEND' + endElem.textContent.substring(path.endOffset);

	var rawTextStart = scratchNodeStart.text(),
		rawTextEnd = scratchNodeEnd.text();

	var ret = {
		start: rawTextStart.indexOf('RWSTART'),
		end: rawTextEnd.indexOf('RWEND')
	};
	var ret2 = validatedIndexes(ret, text.length);

	if (ret.start !== ret2.start || ret.end !== ret2.end) {
		logger.info('path was', JSON.stringify(path));
		logger.info('Got indexes', JSON.stringify(ret));
		logger.info('Validated indexes', JSON.stringify(ret2));

		// CS-109 I expect never to see this message but if we do then we know that
		// rangeToIndexes is giving invalid indexes at times
		logger.error('CS-109 Suppressed invalid indexes from rangeToIndexes');
	}

	return ret2;
};

/**
 * Calls iterator with each text node under parent until the iterator function
 * returns a false (not falsy, must strictly be false)
 *
 * @param  {Function} iterator   called with (node, sourceIndex) for each text node
 * @param  {Element} parent      HTML element to scan for textnodes
 * @return {Boolean}             return value used internally to stop iteration early, ignore this
 */
RangeConverter.prototype.iterateTextNodes = function (iterator, parent) {
	var i,
		stop = false,
		ret;
	for (i = 0; i < parent.childNodes.length && !stop; i++) {
		var n = parent.childNodes[i];

		if (n.nodeType === n.TEXT_NODE) {
			ret = iterator(n);
			if (ret === false) {
				stop = true;
			}
		} else {
			stop = this.iterateTextNodes(iterator, n);
		}
	}
	return stop;
};

module.exports = {
	RangeConverter: RangeConverter,

	isRangeEqual: function (a, b) {
		return a.startContainer === b.startContainer && a.endContainer === b.endContainer && a.startOffset === b.startOffset && a.endOffset === b.endOffset;
	},
	iterateTextNodes: function (iterator, parent) {
		var i,
			stop = false,
			ret;
		for (i = 0; i < parent.childNodes.length && !stop; i++) {
			var n = parent.childNodes[i];

			if (n.nodeType === n.TEXT_NODE) {
				ret = iterator(n);
				if (ret === false) {
					stop = true;
				}
			} else {
				stop = this.iterateTextNodes(iterator, n);
			}
		}
		return stop;
	},
	/**
	 * This function returns a data structure that includes text node and offset
	 * lookup tables. The general idea is if you start in text node X and go 10
	 * characters to the left (or 17 right or whatever), what container are you
	 * in now and at what offset? This helps us do whole word selections.
	 *
	 *
	 * @param  {DOMElement} container the DOM container that contains all valid text nodes
	 * @param  {DOMElement} node      a DOM text node
	 * @param  {number}     offset    where in "node" do we start
	 * @param  {number}     size      how many characters before and after offset to map
	 * @return {object}     an object showing the data, e.g.
	 *                      {
	 *                          textContent:'The text of the node and its surroundings',
	 *                          offset:7, // the offset into textContent that corresponds to the original offset
	 *                          nodesByChar:[], // an array where nodesByChar[n] is the text node for textContent.charAt(n)
	 *                          offsetsByChar:[] // an array where offsetByChar[n] is the offset for textContent.charAt(n)
	 *                      }
	 *
	 */
	getNodeSurroundings: function (container, node, offset, size) {
		var flatNodes = [];
		var originalNodeOffset = null;
		this.iterateTextNodes(function (n) {
			if (n === node) {
				originalNodeOffset = flatNodes.length;
			}

			// the prepend/append parts of this function below cannot handle 0-length
			// text nodes. I'm not sure how it's even possible, when I try to build that
			// in a DOM for a test case, the DOM doesn't seem to let me do it. Since
			// a 0 length node is irrelevent for what we're doing here we'll just skip those
			// nodes in our list.
			if (n.textContent.length > 0) {
				flatNodes.push(n);
			}
		}, container);

		if (originalNodeOffset === null) {
			throw new Error('node is not within container');
		}

		var surroundings = {
			textContent: node.textContent,
			offset: offset,
			nodesByChar: filledArray(node.textContent.length, node),
			offsetsByChar: rangeArray(0, node.textContent.length)
		};

		// prepend to the surroundings until we have at least "size"
		// characters before offset
		var currentNodeIdx = originalNodeOffset;
		var currentOffset = 0;
		while (surroundings.offset < size) {
			currentOffset--;
			if (currentOffset === -1) {
				currentNodeIdx--;
				if (currentNodeIdx === -1) {
					break;
				}

				currentOffset = flatNodes[currentNodeIdx].textContent.length - 1;
			}

			surroundings.offset++;
			surroundings.textContent = flatNodes[currentNodeIdx].textContent.charAt(currentOffset) + surroundings.textContent;

			surroundings.nodesByChar.unshift(flatNodes[currentNodeIdx]);
			surroundings.offsetsByChar.unshift(currentOffset);
		}

		// append to the surroundings until we have at least "size"
		// characters after offset
		currentNodeIdx = originalNodeOffset;
		currentOffset = node.textContent.length - 1;
		while (surroundings.textContent.length - surroundings.offset < size + 1) {
			currentOffset++;
			if (currentOffset === flatNodes[currentNodeIdx].textContent.length) {
				currentNodeIdx++;
				if (currentNodeIdx === flatNodes.length) {
					break;
				}

				currentOffset = 0;
			}

			surroundings.textContent += flatNodes[currentNodeIdx].textContent.charAt(currentOffset);

			surroundings.nodesByChar.push(flatNodes[currentNodeIdx]);
			surroundings.offsetsByChar.push(currentOffset);
		}

		// trim the left of the string and arrays if we have more than "size"
		while (surroundings.offset > size) {
			surroundings.offset--;
			surroundings.textContent = surroundings.textContent.substring(1);
			surroundings.offsetsByChar.shift();
			surroundings.nodesByChar.shift();
		}

		// trim the right of the string and arrays if we have more than "size"
		while (surroundings.textContent.length - surroundings.offset > size + 1) {
			surroundings.textContent = surroundings.textContent.substring(0, surroundings.textContent.length - 1);
			surroundings.offsetsByChar.pop();
			surroundings.nodesByChar.pop();
		}

		return surroundings;
	},
	getRangeSurroundings: function (range, parent, maxContext) {
		var startContainer = range.startContainer,
			endContainer = range.endContainer;

		// A triple click to select the whole paragraph results in an endContainer that's not a TEXT_NODE
		// for good measure we check both start and end containers for this issue.
		// If the user did this, there's no need to check surroundings to find whole words
		// so just return null (in development it proved difficult to deal with this case)
		if (endContainer.nodeType !== endContainer.TEXT_NODE || startContainer.nodeType !== startContainer.TEXT_NODE) {
			return null;
		}

		return {
			start: this.getNodeSurroundings(parent, startContainer, range.startOffset, 20),
			end: this.getNodeSurroundings(parent, endContainer, range.endOffset - 1, 20)
		};
	},
	_ensureId: function (el) {
		if (el.id) {
			return;
		}

		var id = new Date().getTime();
		var document = el;
		while (document.nodeName !== '#document') {
			document = document.parentNode;
		}
		while (document.getElementById('htmlutil-' + id)) {
			id++;
		}
		el.id = 'htmlutil-' + id;
	},
	isDescendant: function (el, parent) {
		while (el.parentNode) {
			if (el.parentNode == parent) {
				return true;
			}
			el = el.parentNode;
		}

		return false;
	},
	whenInDOM: function (el, cb) {
		var startedAt = new Date().getTime();
		if (this.isDescendant(el, document.body)) {
			cb();
		} else if (new Date().getTime() - startedAt < 1200) {
			setTimeout(
				function () {
					this.whenInDOM(el, cb);
				}.bind(this),
				15
			);
		} else {
			logger.error('NOT IN DOM, whenInDOM is giving up');
		}
	},
	isVisible(element) {
		return element.offsetHeight > 0 || element.offsetWidth > 0;
	}
};
